import type { ImageDataLike } from 'gatsby-plugin-image';
import { graphql, useStaticQuery } from 'gatsby';


function useGamePreviewImageQuery(): ImageDataLike | null {
  const data = useStaticQuery(graphql`
    query GamePreviewImage {
      file(sourceInstanceName: { eq: "images" }, relativePath: { eq: "game-preview.png" }) {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  `);

  return data.file;
}

export default useGamePreviewImageQuery;
